/**
 * Scheme allowlist for a Shippo label URL before it is bound to an ``img``
 * ``src`` or an anchor ``href``. Only ``http:``/``https:`` are permitted so a
 * ``javascript:``/``data:`` URL can never become a live preview or link sink.
 * Relative/opaque URLs (no scheme) are rejected — a real Shippo label is always
 * an absolute http(s) URL.
 *
 * Split out from `ShippingLabelModal.tsx` so the component module only exports
 * components (keeps React Fast Refresh happy).
 */
export function isSafeLabelUrl(labelUrl: string | undefined): boolean {
  if (typeof labelUrl !== 'string' || labelUrl.trim().length === 0) return false
  try {
    const parsed = new URL(labelUrl)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}
